module.exports = __webpack_public_path__ + "assets/img/D-2.bb6bfd5b.jpg";